import { 
  FETCH_TEAM_MEMBERS, 
  FETCH_TEAM_MEMBERS_SUCCESS, 
  FETCH_TEAM_MEMBERS_FAILURE,
  DELETE_TEAM_MEMBER,
  DELETE_TEAM_MEMBER_SUCCESS,
  DELETE_TEAM_MEMBER_FAILURE,
  ADD_TEAM_MEMBER,
  ADD_TEAM_MEMBER_SUCCESS,
  ADD_TEAM_MEMBER_FAILURE,
  UPDATE_TEAM_MEMBER,
  UPDATE_TEAM_MEMBER_SUCCESS,
  UPDATE_TEAM_MEMBER_FAILURE,
  FETCH_PROJECT_ROLES,
  FETCH_PROJECT_ROLES_SUCCESS,
  FETCH_PROJECT_ROLES_FAILURE,
  FETCH_CERTIFICATIONS,
  FETCH_CERTIFICATIONS_SUCCESS,
  FETCH_CERTIFICATIONS_FAILURE,
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  GET_PRESIGNED_URL,
  GET_PRESIGNED_URL_SUCCESS,
  GET_PRESIGNED_URL_FAILURE,
  UPLOAD_CERTIFICATE,
  UPLOAD_CERTIFICATE_SUCCESS,
  UPLOAD_CERTIFICATE_FAILURE,
  CREATE_UPDATE_TEAM_MEMBER,
  CREATE_UPDATE_TEAM_MEMBER_SUCCESS,
  CREATE_UPDATE_TEAM_MEMBER_FAILURE,
  DELETE_TEAM_MEMBER_CERT,
  DELETE_TEAM_MEMBER_CERT_SUCCESS,
  DELETE_TEAM_MEMBER_CERT_FAILURE,
  CREATE_UPDATE_PROJECT_LEVEL_ROLES,
  CREATE_UPDATE_PROJECT_LEVEL_ROLES_SUCCESS,
  CREATE_UPDATE_PROJECT_LEVEL_ROLES_FAILURE,
  DELETE_PROJECT_LEVEL_ROLE,
  DELETE_PROJECT_LEVEL_ROLE_SUCCESS,
  DELETE_PROJECT_LEVEL_ROLE_FAILURE
} from './types';

// Fetch team members
export const fetchTeamMembers = (payload) => ({
  type: FETCH_TEAM_MEMBERS,
  payload
});

export const fetchTeamMembersSuccess = (payload) => ({
  type: FETCH_TEAM_MEMBERS_SUCCESS,
  payload
});

export const fetchTeamMembersFailure = (error) => ({
  type: FETCH_TEAM_MEMBERS_FAILURE,
  error
});

// Delete team member
export const deleteTeamMember = (payload) => ({
  type: DELETE_TEAM_MEMBER,
  payload
});

export const deleteTeamMemberSuccess = (payload) => ({
  type: DELETE_TEAM_MEMBER_SUCCESS,
  payload
});

export const deleteTeamMemberFailure = (error) => ({
  type: DELETE_TEAM_MEMBER_FAILURE,
  error
});

// Add team member
export const addTeamMember = (payload) => ({
  type: ADD_TEAM_MEMBER,
  payload
});

export const addTeamMemberSuccess = (payload) => ({
  type: ADD_TEAM_MEMBER_SUCCESS,
  payload
});

export const addTeamMemberFailure = (error) => ({
  type: ADD_TEAM_MEMBER_FAILURE,
  error
});

// Update team member
export const updateTeamMember = (payload) => ({
  type: UPDATE_TEAM_MEMBER,
  payload
});

export const updateTeamMemberSuccess = (payload) => ({
  type: UPDATE_TEAM_MEMBER_SUCCESS,
  payload
});

export const updateTeamMemberFailure = (error) => ({
  type: UPDATE_TEAM_MEMBER_FAILURE,
  error
});

// Fetch project roles
export const fetchProjectRoles = (payload) => ({
  type: FETCH_PROJECT_ROLES,
  payload
});

export const fetchProjectRolesSuccess = (payload) => ({
  type: FETCH_PROJECT_ROLES_SUCCESS,
  payload
});

export const fetchProjectRolesFailure = (error) => ({
  type: FETCH_PROJECT_ROLES_FAILURE,
  error
});

// Fetch certifications
export const fetchCertifications = (payload) => {
  return {
    type: FETCH_CERTIFICATIONS,
    payload
  };
};

export const fetchCertificationsSuccess = (payload) => ({
  type: FETCH_CERTIFICATIONS_SUCCESS,
  payload
});

export const fetchCertificationsFailure = (error) => ({
  type: FETCH_CERTIFICATIONS_FAILURE,
  error
});

// Fetch users
export const fetchUsers = (payload) => ({
  type: FETCH_USERS,
  payload
});

export const fetchUsersSuccess = (payload) => ({
  type: FETCH_USERS_SUCCESS,
  payload
});

export const fetchUsersFailure = (error) => ({
  type: FETCH_USERS_FAILURE,
  error
});

// Get presigned URL
export const getPresignedUrl = (payload) => ({
  type: GET_PRESIGNED_URL,
  payload
});

export const getPresignedUrlSuccess = (payload) => ({
  type: GET_PRESIGNED_URL_SUCCESS,
  payload
});

export const getPresignedUrlFailure = (error) => ({
  type: GET_PRESIGNED_URL_FAILURE,
  error
});

// Upload certificate
export const uploadCertificate = (payload) => ({
  type: UPLOAD_CERTIFICATE,
  payload
});

export const uploadCertificateSuccess = (payload) => ({
  type: UPLOAD_CERTIFICATE_SUCCESS,
  payload
});

export const uploadCertificateFailure = (error) => ({
  type: UPLOAD_CERTIFICATE_FAILURE,
  error
});

// Create/Update team member
export const createUpdateTeamMember = (payload) => {
  
  return {
    type: CREATE_UPDATE_TEAM_MEMBER,
    payload
  };
};

export const createUpdateTeamMemberSuccess = (payload) => ({
  type: CREATE_UPDATE_TEAM_MEMBER_SUCCESS,
  ...payload
});

export const createUpdateTeamMemberFailure = (error) => ({
  type: CREATE_UPDATE_TEAM_MEMBER_FAILURE,
  error
});

// Delete team member certificate actions
export const deleteTeamMemberCert = (certId, projectId) => ({
  type: DELETE_TEAM_MEMBER_CERT,
  payload: { certId, projectId }
});

export const deleteTeamMemberCertSuccess = (payload) => ({
  type: DELETE_TEAM_MEMBER_CERT_SUCCESS,
  ...payload
});

export const deleteTeamMemberCertFailure = (error) => ({
  type: DELETE_TEAM_MEMBER_CERT_FAILURE,
  error
});

// Create/Update project level roles
export const createUpdateProjectLevelRoles = (payload) => ({
  type: CREATE_UPDATE_PROJECT_LEVEL_ROLES,
  payload
});

export const createUpdateProjectLevelRolesSuccess = (payload) => ({
  type: CREATE_UPDATE_PROJECT_LEVEL_ROLES_SUCCESS,
  payload
});

export const createUpdateProjectLevelRolesFailure = (error) => ({
  type: CREATE_UPDATE_PROJECT_LEVEL_ROLES_FAILURE,
  error
});

// Delete project level role
export const deleteProjectLevelRole = (payload) => ({
  type: DELETE_PROJECT_LEVEL_ROLE,
  payload
});

export const deleteProjectLevelRoleSuccess = (payload) => ({
  type: DELETE_PROJECT_LEVEL_ROLE_SUCCESS,
  payload
});

export const deleteProjectLevelRoleFailure = (error) => ({
  type: DELETE_PROJECT_LEVEL_ROLE_FAILURE,
  error
});

// Clear error action
export const clearTeamMembersError = () => ({
  type: 'CLEAR_TEAM_MEMBERS_ERROR'
});